<template>
  <v-form>
    <v-container>

      <!-- Título -->
      <v-col cols="12">
        <h2>Recepción Somatometría</h2>
      </v-col>

      <!-- Búsqueda -->
      <v-sheet
        class="pa-4 mb-6"
        rounded="lg"
        elevation="1"
      >
        <v-row align="center">
          <v-col cols="12" md="4">
            <v-text-field
              v-model="expPaciente"
              label="Número de expediente del paciente"
              outlined
              shaped
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="folioCita"
              label="Folio de la cita"
              outlined
              shaped
            />
          </v-col>

          <v-col cols="12" md="4" class="d-flex align-end">
            <v-btn
              color="success"
              rounded
              dark
              @click="buscaCita"
            >
              <v-icon left>mdi-text-box-search</v-icon>
              Buscar cita
            </v-btn>
          </v-col>
        </v-row>
      </v-sheet>

      <!-- Datos de la cita -->
      <v-sheet
        class="pa-4"
        color="grey lighten-5"
        rounded="lg"
        elevation="1"
      >
        <h2 class="mb-4">Datos de la cita</h2>

        <v-row>
          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Folio de la cita</div>
            <div class="value" v-if="cita">
              {{ cita.citaId }}
            </div>
            <div class="value " v-else>-</div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Tipo</div>
            <div class="value" v-if="cita">{{ cita.tipo }}</div>
            <div class="value" v-else>-</div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Paciente</div>
            <div class="value" v-if="cita">{{ cita.paciente }}</div>
            <div class="value" v-else>-</div>
          </v-col>

          <v-col cols="12" md="3">
            <div class="label font-weight-bold">Edad</div>
            <div class="value" v-if="cita">{{ cita.edad }}</div>
            <div class="value" v-else>-</div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Médico</div>
            <div class="value" v-if="cita">{{ cita.medico }}</div>
            <div class="value" v-else>-</div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Consultorio</div>
            <div class="value" v-if="cita">{{ cita.consultorio }}</div>
            <div class="value" v-else>-</div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Fecha de la cita</div>
            <div class="value" v-if="cita">{{ cita.fecha }}</div>
            <div class="value" v-else>-</div>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet
        class="pa-4 mt-6"
        color="grey lighten-5"
        rounded="lg"
        elevation="1"
        >
        <v-col cols="12" md="6">
            <div class="label font-weight-bold">Observaciones</div>
            <div class="value" v-if="cita">{{ cita.observacionesIngreso }}</div>
            <div class="value" v-else>-</div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Creado por</div>
            <div class="value" v-if="cita">{{ cita.creado}}</div>
            <div class="value" v-else>-</div>
          </v-col>
      </v-sheet>

    </v-container>
  </v-form>
</template>


<script>
import Swal from "sweetalert2"
import 'sweetalert2/dist/sweetalert2.min.css'

export default {
  name: 'Somatometria',
  data() {
  return {
    cita: null,
    expPaciente: '',
    folioCita: ''
  }
},
  methods: {
    
   async buscaCita () {
  this.loadingBuscaCita = true

  try {
    let identificador = ''
    // Validación
    if(this.expPaciente != ''){
        if(this.expPaciente < 10000009) {
        Swal.fire({
            icon: 'warning',
            title: 'El número de expediente no es válido'
        })
        return
        }
    }else if(this.folioCita != ''){
        if (!this.folioCita || this.folioCita < 100) {
        Swal.fire({
            icon: 'warning',
            title: 'El número de folio no es válido'
        })
        return
        }
    }else {
        Swal.fire({
            icon: 'warning',
            title: 'Ingrese un criterio de búsqueda'
        })
        return
    }
    if(this.expPaciente != ''){
        identificador = this.expPaciente
    } else {
        identificador = this.folioCita
    }
    

    // Llamada al backend
    const response = await this.$http({
      url: 'consulta/getCita',
      method: 'GET',
      params: { id: identificador }
    })

    // Asignar datos
    this.cita = response.data.root

  } catch (err) {
    console.error(err)
    this.cita = null

    this.$store.dispatch('security/revisaError', err)

  } finally {
    this.loadingBuscaCita = false
  }
}

  }
}
</script>

<style scoped>
.label {
  font-size: 0.95rem;
  color: #757575;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.value {
  font-size: 1rem;
  font-weight: 500;
  color: #4e0404;
}
</style>

